import { render, staticRenderFns } from "./InterestRateType.vue?vue&type=template&id=55e9c67b"
import script from "./InterestRateType.vue?vue&type=script&lang=js"
export * from "./InterestRateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports